/**
 * Returns the rooms
 */
export function getRooms(
  data?: Content.Components['SimplePassengerModuleDto'],
): Content.Properties.Room[] {
  if (!data) return [];

  if (!Array.isArray(data.rooms)) return [];

  return data.rooms;
}
